/**
 * The demonstration-environment notice.
 *
 * Renders on every deployment that is not a declared production project, above
 * everything else, so it is read before a visitor decides whether to type
 * anything real. Returns null on production so there is no per-page cost and no
 * banner to explain away once the service is genuinely live.
 *
 * Placed here rather than on the landing page alone because the risk it warns
 * about — uploading a real deed — lives on the case screens, which a returning
 * visitor reaches without passing the landing copy again.
 */
import { DEMO_NOTICE, IS_PRODUCTION_DEPLOYMENT } from "./environment.js";

export function EnvironmentNotice() {
  if (IS_PRODUCTION_DEPLOYMENT) return null;
  return (
    <div className="notice" role="status">
      <strong>{DEMO_NOTICE}</strong>
    </div>
  );
}
